import { render, staticRenderFns } from "./TaxIndex.vue?vue&type=template&id=3a9fa9a7&scoped=true&"
import script from "./TaxIndex.vue?vue&type=script&lang=js&"
export * from "./TaxIndex.vue?vue&type=script&lang=js&"
import style0 from "./TaxIndex.vue?vue&type=style&index=0&id=3a9fa9a7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9fa9a7",
  null
  
)

export default component.exports